import React, { useEffect, useState } from "react";
import Layout from "../Shared/Layout";
import {
    Box,
    Button,
    Collapse,
    Container,
    Grid,
    IconButton,
    InputLabel,
    Link,
    MenuItem,
    Select,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableSortLabel,
    Typography,
} from "@material-ui/core";
import "date-fns";
import styled, { css } from "styled-components";
import FormPage from "../Shared/FormPage";
import { InertiaLink, usePage } from "@inertiajs/inertia-react";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import TextField from "@material-ui/core/TextField";
import StatusFlow from "../Shared/StatusFlow/StatusFlow";
import MuiButton from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/styles";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import CreateIcon from "@material-ui/icons/Create";
import BackButton from "../Shared/BackButton";
import { Inertia } from "@inertiajs/inertia";
import FormControl from "@material-ui/core/FormControl";
import GetApp from "@material-ui/icons/GetApp";
import DateFnsUtils from "@date-io/date-fns";
import { format } from "date-fns-tz";
import Pagination from "@material-ui/lab/Pagination";
import PermPhoneMsgIcon from "@material-ui/icons/PermPhoneMsg";

import {
    MuiPickersUtilsProvider,
    KeyboardTimePicker,
    KeyboardDatePicker,
} from "@material-ui/pickers";
import Publish from "@material-ui/icons/Publish";
import { Trans } from "../utils/i18n";
import { QueueTable } from "../Shared/QueueTable";
import { QueueRowCompact } from "../Shared/QueueRowCompact";

const Wrapper = styled.div``;

const H1 = styled.h1`
    display: inline-block;
    margin-right: 30px;
`;

const TabLink = styled(InertiaLink)`
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.25);
    text-align: center;
    padding: 30px;
    font-size: 20px;
    display: block;
    text-decoration: none;
    color: ${(props) => props.theme.secondary};
    ${(props) =>
        props.$active &&
        css`
            background-color: ${(props) => props.theme.primary};
            color: white;
        `}
`;

const PaginationWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 15px;
`;

export default function Queues({
    results,
    requesttypes,
    active_requesttype,
    pages,
    extendedMode,
    partners,
    companies,
    defaultFilter,
}) {
    const [service, setService] = useState(defaultFilter.service_id || "");
    const [status, setStatus] = useState(defaultFilter.status_id || "");
    const [partner, setPartner] = useState(defaultFilter.partner_id || "");
    const [company, setCompany] = useState(defaultFilter.company_id || "");
    const [search, setSearch] = useState(defaultFilter.search || "");
    const [dateFrom, setDateFrom] = useState(
        defaultFilter.created_at_from
            ? new Date(defaultFilter.created_at_from)
            : null
    );
    const [dateOfService, setDateOfService] = useState(
        defaultFilter.dateOfService
            ? new Date(defaultFilter.dateOfService)
            : null
    );
    const [dateTo, setDateTo] = useState(
        defaultFilter.created_at_to
            ? new Date(defaultFilter.created_at_to)
            : null
    );
    const [orderBy, setOrderBy] = useState(defaultFilter.orderBy || "");
    const [dirty, setDirty] = useState(false);
    const [orderDirection, setOrderDirection] = useState("desc");
    const { client, permissions } = usePage().props;

    const setFormDirty = (callback) => {
        if (!dirty) {
            setDirty(true);
        }
        callback();
    };

    const initialPage = parseInt(
        new URLSearchParams(location.search).get("page") || 1
    );
    const [page, setPage] = useState(initialPage);

    useEffect(() => {
        if (!dirty) {
            return;
        }
        if (
            service ||
            dateOfService ||
            status ||
            partner ||
            company ||
            search ||
            dateFrom !== null ||
            dateTo !== null ||
            page ||
            orderBy ||
            orderDirection
        ) {
            Inertia.get(
                route("queue.index"),
                {
                    requesttype: active_requesttype,
                    search: search,
                    partner_id: partner !== "all" ? partner : undefined,
                    company_id: company !== "all" ? company : undefined,
                    status_id: status !== "all" ? status : undefined,
                    service_id: service !== "all" ? service : undefined,
                    dateOfService: dateOfService
                        ? format(dateOfService, "yyyy-MM-dd")
                        : null,
                    created_at_from: dateFrom
                        ? format(dateFrom, "yyyy-MM-dd")
                        : null,
                    created_at_to: dateTo ? format(dateTo, "yyyy-MM-dd") : null,
                    page: page,
                    orderBy,
                    orderDirection,
                },
                {
                    preserveState: true,
                    replace: true,
                }
            );
        }
    }, [
        service,
        dateOfService,
        status,
        partner,
        company,
        search,
        dateFrom,
        dateTo,
        page,
        orderBy,
        orderDirection,
    ]);

    const updateDateFrom = (value) => {
        if (value === null) {
            setFormDirty(() => setDateFrom(""));
        }
        if (
            Object.prototype.toString.call(value) === "[object Date]" &&
            !isNaN(value.getTime())
        ) {
            setFormDirty(() => setDateFrom(value));
        }
    };

    const updateDateTo = (value) => {
        if (value === null) {
            setFormDirty(() => setDateTo(null));
        }

        if (
            Object.prototype.toString.call(value) === "[object Date]" &&
            !isNaN(value.getTime())
        ) {
            setFormDirty(() => setDateTo(value));
        }
    };

    const updateDateOfService = (value) => {
        if (value === null) {
            setFormDirty(() => setDateOfService(null));
        }

        if (
            Object.prototype.toString.call(value) === "[object Date]" &&
            !isNaN(value.getTime())
        ) {
            setFormDirty(() => setDateOfService(value));
        }
    };

    const downloadUrl = new URL(window.location.href);
    downloadUrl.searchParams.append("print", "");
    
    const handlePageChage = async (_, value) => {
        setFormDirty(() => setPage(value));
    };

    return (
        <Wrapper>
            <Container maxWidth="lg">
                <Grid container spacing={3} alignItems="center">
                    <Grid item xs={8} style={{ marginBottom: 30 }}>
                        <BackButton />
                    </Grid>
                    {permissions.includes("queue_agent") && (
                        <Grid
                            item
                            xs={4}
                            style={{
                                marginBottom: 30,
                                display: "flex",
                                justifyContent: "flex-end",
                            }}
                        >
                            <Button
                                variant="contained"
                                color="secondary"
                                endIcon={
                                    <PermPhoneMsgIcon>
                                        <Trans i18nKey="queues.agentButton">
                                            Open Chat
                                        </Trans>
                                    </PermPhoneMsgIcon>
                                }
                                href={route("admin.agent")}
                                target="_blank"
                            >
                                <Trans i18nKey="queues.agentButton">
                                    Open Chat
                                </Trans>
                            </Button>
                        </Grid>
                    )}

                    {permissions.includes("queue_import") && (
                        <Grid item xs={12}>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                }}
                            >
                                <H1>
                                    <Trans i18nKey="queues">Queues</Trans>
                                </H1>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    endIcon={
                                        <Publish>
                                            <Trans i18nKey="queues.send">
                                                send
                                            </Trans>
                                        </Publish>
                                    }
                                    href={route("queue.import")}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        Inertia.visit(route("queue.import"));
                                    }}
                                >
                                    <Trans i18nKey="queues.import">
                                        Import
                                    </Trans>
                                </Button>
                            </div>
                        </Grid>
                    )}
                </Grid>

                <Grid container spacing={3}>
                    {
                        requesttypes.map((item) => (
                            <Grid
                                item
                                xs={12}
                                sm={requesttypes.length > 3 ? 3 : 4}
                                key={item.key}
                            >
                                <TabLink
                                    href={route("queue.index", {
                                        requesttype: item.key,
                                    })}
                                    $active={active_requesttype === item.key}
                                >
                                    {item.name}
                                </TabLink>
                            </Grid>
                        ))}
                </Grid>

                {extendedMode && (
                    <>
                        <br />
                        <br />
                        <hr />
                        <br />
                        <br />
                    </>
                )}

                <Grid container spacing={3}>
                    <Grid item xs={12} md={12} xl={12}>
                        <TextField
                            id="email"
                            label={
                                <Trans i18nKey="common.search">Search</Trans>
                            }
                            value={search}
                            onChange={(e) =>
                                setFormDirty(() => setSearch(e.target.value))
                            }
                            name="search"
                            type="text"
                            variant="outlined"
                            style={{
                                marginBottom: extendedMode ? "25px" : undefined,
                            }}
                        />
                    </Grid>
                    {extendedMode && (
                        <Grid item xs={12} md={2} xl={2}>
                            <FormControl variant="outlined">
                                <InputLabel id="filter-service">
                                    <Trans i18nKey="queues.service">Service</Trans>
                                </InputLabel>
                                <Select
                                    labelId="filter-service"
                                    label={
                                        <Trans i18nKey="queues.service">
                                            Service
                                        </Trans>
                                    }
                                    value={service}
                                    onChange={(e) =>
                                        setFormDirty(() => setService(e.target.value))
                                    }
                                >
                                    <MenuItem value="all">
                                        <Trans i18nKey="queues.all">All</Trans>
                                    </MenuItem>
                                    {requesttypes
                                        .reduce(
                                            (carry, item) => [
                                                ...carry,
                                                ...item.services,
                                            ],
                                            []
                                        )
                                        .reduce((carry, item) => {
                                            if (
                                                !carry.find(
                                                    (arrayItem) =>
                                                        arrayItem.id === item.id
                                                )
                                            ) {
                                                carry.push(item);
                                            }
                                            return carry;
                                        }, [])
                                        .map((service) => {
                                            return (
                                                <MenuItem
                                                    key={service.id}
                                                    value={service.id}
                                                >
                                                    {service.name}
                                                </MenuItem>
                                            );
                                        })}
                                    <MenuItem value="noservice">
                                        <Trans i18nKey="services.noservice">
                                            No service
                                        </Trans>
                                    </MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    )}
                    <Grid item xs={12} md={2} xl={2}>
                        <FormControl variant="outlined">
                            <InputLabel id="filter-status"><Trans i18nKey="queues.status">Status</Trans></InputLabel>
                            <Select
                                labelId="filter-status"
                                label={
                                    <Trans i18nKey="queues.status">
                                        Status
                                    </Trans>
                                }
                                value={status}
                                onChange={(e) =>
                                    setFormDirty(() => setStatus(e.target.value))
                                }
                            >
                                <MenuItem value="all">
                                    <Trans i18nKey="queues.all">All</Trans>
                                </MenuItem>
                                {requesttypes
                                    .reduce(
                                        (carry, item) => [
                                            ...carry,
                                            ...item.services,
                                        ],
                                        []
                                    )
                                    .reduce(
                                        (carry, item) => [
                                            ...carry,
                                            ...item.statuses,
                                        ],
                                        []
                                    )
                                    .reduce((carry, item) => {
                                        if (
                                            !carry.find(
                                                (arrayItem) =>
                                                    arrayItem.id === item.id
                                            )
                                        ) {
                                            carry.push(item);
                                        }
                                        return carry;
                                    }, [])
                                    .map((status) => {
                                        return (
                                            <MenuItem
                                                key={status.id}
                                                value={status.id}
                                            >
                                                {status.name}
                                            </MenuItem>
                                        );
                                    })}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={2} xl={2}>
                        <FormControl variant="outlined">
                            <InputLabel id="filter-partner"><Trans i18nKey="queues.partner">Partner</Trans></InputLabel>
                            <Select
                                labelId="filter-partner"
                                label={
                                    <Trans i18nKey="queues.partner">
                                        Partner
                                    </Trans>
                                }
                                value={partner}
                                onChange={(e) =>
                                    setFormDirty(() => setPartner(e.target.value))
                                }
                            >
                                <MenuItem value="all">
                                    <Trans i18nKey="queues.all">All</Trans>
                                </MenuItem>
                                {partners.map((status) => {
                                    return (
                                        <MenuItem
                                            key={status.id}
                                            value={status.id}
                                        >
                                            {status.name}
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        </FormControl>
                    </Grid>
                    {extendedMode && (
                        <Grid item xs={12} md={2} xl={2}>
                            <FormControl variant="outlined">
                                <InputLabel id="filter-company"><Trans i18nKey="queues.company">Company</Trans></InputLabel>
                                <Select
                                    labelId="filter-company"
                                    label={
                                        <Trans i18nKey="queues.company">
                                            Company
                                        </Trans>
                                    }
                                    value={company}
                                    onChange={(e) =>
                                        setFormDirty(() => setCompany(e.target.value))
                                    }
                                >
                                    <MenuItem value="all">
                                        <Trans i18nKey="queues.all">All</Trans>
                                    </MenuItem>

                                    {companies.map((company) => {
                                        return (
                                            <MenuItem
                                                key={company.id}
                                                value={company.id}
                                            >
                                                {company.name}
                                            </MenuItem>
                                        );
                                    })}
                                </Select>
                            </FormControl>
                        </Grid>
                    )}
                    {!extendedMode && (
                        <Grid item xs={12} sm={4} md={2} xl={2}>
                            <Grid container justify="space-around">
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                        clearable
                                        inputVariant="outlined"
                                        label={
                                            <Trans i18nKey="queues.dateOfService">
                                                Date of service
                                            </Trans>
                                        }
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        value={dateOfService}
                                        // placeholder="10.10.2021"
                                        onChange={updateDateOfService}
                                        format="dd.MM.yyyy"
                                        autoOk={true}
                                        error={false}
                                        invalidDateMessage={<span></span>}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                        </Grid>
                    )}
                    <br />
                    {extendedMode && (
                        <Grid item xs={12} sm={4} md={2} xl={2}>
                            <Grid container justify="space-around">
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                        clearable
                                        inputVariant="outlined"
                                        label={
                                            <Trans i18nKey="queues.from">
                                                From
                                            </Trans>
                                        }
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        value={dateFrom}
                                        // placeholder="10.10.2021"
                                        onChange={updateDateFrom}
                                        format="dd.MM.yyyy"
                                        autoOk={true}
                                        error={false}
                                        invalidDateMessage={<span></span>}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                        </Grid>
                    )}
                    {extendedMode && (
                        <Grid item xs={12} sm={4} md={2} xl={2}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    clearable
                                    inputVariant="outlined"
                                    label={
                                        <Trans i18nKey="queues.to">To</Trans>
                                    }
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={dateTo}
                                    // placeholder="10.10.2021"
                                    onChange={updateDateTo}
                                    format="dd.MM.yyyy"
                                    autoOk={true}
                                    error={false}
                                    invalidDateMessage={<span></span>}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                    )}
                </Grid>

                <br />
                <br />

                <Grid container spacing={3}>
                    {extendedMode && permissions.includes("queue_export") && (
                        <Grid item xs={12} sm={4} md={2}>
                            <Button
                                variant="contained"
                                color="secondary"
                                endIcon={<GetApp>send</GetApp>}
                                href={downloadUrl.href}
                            >
                                <Trans i18nKey="queues.download">
                                    Download
                                </Trans>
                            </Button>
                        </Grid>
                    )}
                </Grid>

                <br />

                {!extendedMode && (
                    <div>
                        {results.map((row) => (
                            <QueueRowCompact
                                key={row.order_id + row.number}
                                row={row}
                                returnUrl={route("queue.index", {
                                    requesttype: active_requesttype,
                                    search: search,
                                    partner_id:
                                        partner !== "all" ? partner : undefined,
                                    status_id:
                                        status !== "all" ? status : undefined,
                                    service_id:
                                        service !== "all" ? service : undefined,
                                    dateOfService: dateOfService
                                        ? format(dateOfService, "yyyy-MM-dd")
                                        : null,
                                    created_at_from: dateFrom
                                        ? format(dateFrom, "yyyy-MM-dd")
                                        : null,
                                    created_at_to: dateTo
                                        ? format(dateTo, "yyyy-MM-dd")
                                        : null,
                                    page: page,
                                    orderBy,
                                    orderDirection,
                                })}
                            />
                        ))}
                    </div>
                )}
                {extendedMode && (
                    <QueueTable
                        orderBy={orderBy}
                        setOrderBy={(value) => setFormDirty(() => setOrderBy(value))}
                        setOrderDirection={(value) =>
                            setFormDirty(() => setOrderDirection(value))
                        }
                        results={results}
                        orderDirection={orderDirection}
                        returnUrl={route("queue.index", {
                            requesttype: active_requesttype,
                            search: search,
                            partner_id: partner !== "all" ? partner : undefined,
                            status_id: status !== "all" ? status : undefined,
                            service_id: service !== "all" ? service : undefined,
                            dateOfService: dateOfService
                                ? format(dateOfService, "yyyy-MM-dd")
                                : null,
                            created_at_from: dateFrom
                                ? format(dateFrom, "yyyy-MM-dd")
                                : null,
                            created_at_to: dateTo
                                ? format(dateTo, "yyyy-MM-dd")
                                : null,
                            page: page,
                            orderBy,
                            orderDirection,
                        })}
                    />
                )}

                <PaginationWrapper>
                    {pages > 1 && (
                        <Pagination
                            count={pages}
                            page={page}
                            color={"primary"}
                            onChange={handlePageChage}
                        />
                    )}
                </PaginationWrapper>
            </Container>
        </Wrapper>
    );
}

Queues.layout = (page) => <Layout children={page} />;
